import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Plus } from 'lucide-react';

export default function CarRateDialog({
  showCarRateDialog,
  setShowCarRateDialog,
  editingCarRate,
  setEditingCarRate,
  carRateForm,
  setCarRateForm,
  resetCarRateForm,
  handleCreateCarRate,
  handleUpdateCarRate
}) {
  return (
    <Dialog open={showCarRateDialog} onOpenChange={(open) => {
      setShowCarRateDialog(open);
      if (!open) {
        setEditingCarRate(null);
        resetCarRateForm();
      }
    }}>
      <DialogTrigger asChild>
        <Button size="sm" className="bg-gradient-to-r from-blue-600 to-indigo-600" data-testid="add-car-rate-btn">
          <Plus className="w-4 h-4 mr-2" />
          Add Rate
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{editingCarRate ? 'Edit Rate' : 'Add Rate'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={editingCarRate ? handleUpdateCarRate : handleCreateCarRate} className="space-y-4">
          <div>
            <Label htmlFor="car_rate_start">Start Date *</Label>
            <Input
              id="car_rate_start"
              type="date"
              value={carRateForm.start_date}
              onChange={(e) => setCarRateForm({ ...carRateForm, start_date: e.target.value })}
              required={!editingCarRate}
              data-testid="car-rate-start-input"
            />
          </div>
          <div>
            <Label htmlFor="car_rate_end">End Date *</Label>
            <Input
              id="car_rate_end"
              type="date"
              value={carRateForm.end_date}
              onChange={(e) => setCarRateForm({ ...carRateForm, end_date: e.target.value })}
              required={!editingCarRate}
              data-testid="car-rate-end-input"
            />
          </div>
          <div>
            <Label htmlFor="car_rate_price">Price (€) *</Label>
            <Input
              id="car_rate_price"
              type="number"
              step="0.01"
              placeholder="e.g., 75.00"
              value={carRateForm.price}
              onChange={(e) => setCarRateForm({ ...carRateForm, price: e.target.value })}
              required={!editingCarRate}
              data-testid="car-rate-price-input"
            />
          </div>
          <Button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-indigo-600" data-testid="save-car-rate-btn">
            {editingCarRate ? 'Update Rate' : 'Create Rate'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
